// import React, { useState } from "react";
// import s from "./ProjectsList.module.css";
// import { Link } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";

// export default function ProjectsList({ projects }) {
//   const [hoveredProject, setHoveredProject] = useState(null);

//   return (
//     <div className={s.projectsList}>
//       {projects.map((project) => (
//         <div
//           key={project.id}
//           className={`${s.projectItem} ${project.video ? s.hasVideo : ""}`}
//           onMouseEnter={() => setHoveredProject(project.id)}
//           onMouseLeave={() => setHoveredProject(null)}
//         >
//           <Link to={`/project/${project.id}`}>
//             {/* Статичное изображение */}
//             <LazyLoadImage
//               src={process.env.PUBLIC_URL + project.image}
//               alt={project.title}
//               className={`${s.projectImage} ${
//                 hoveredProject === project.id ? s.hidden : ""
//               }`}
//             />

//             {/* Видео при наведении */}
//             {project.video ? (
//               <video
//                 className={`${s.projectVideo} ${
//                   hoveredProject === project.id ? s.visible : s.hidden
//                 }`}
//                 src={process.env.PUBLIC_URL + project.video}
//                 type="video/mp4"
//                 muted
//                 loop
//                 playsInline
//                 onMouseEnter={(e) => e.target.play()}
//                 onMouseLeave={(e) => {
//                   e.target.pause();
//                   e.target.currentTime = 0;
//                 }}
//                 onError={(e) => {
//                   console.error("Ошибка загрузки видео", e);
//                 }}
//               />
//             ) : (
//               <div className={s.placeholderVideo}></div>
//             )}
//           </Link>

//           {/* Заголовок проекта (всегда поверх) */}
//           <div className={s.projectTitle}>{project.title}</div>
//         </div>
//       ))}
//     </div>
//   );
// }

import React, { useState } from "react";
import s from "./ProjectsList.module.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function ProjectsList({ projects }) {
  const [hoveredProject, setHoveredProject] = useState(null);

  return (
    <div className={s.projectsList}>
      {projects.map((project) => (
        <div
          key={project.id}
          // className={`${s.projectItem} ${project.video ? s.hasVideo : ""}`}
          className={`${s.projectItem} ${project.video ? s.hasVideo : ""} ${
            project.id === 16 ? s.project16fix : ""
          }`}
          onMouseEnter={() => setHoveredProject(project.id)}
          onMouseLeave={() => setHoveredProject(null)}
        >
          <Link to={`/project/${project.id}`}>
            {/* Статичное изображение */}
            <LazyLoadImage
              src={process.env.PUBLIC_URL + project.image}
              alt={project.title}
              className={`${s.projectImage} ${
                hoveredProject === project.id ? s.hidden : ""
              }`}
            />

            {project.video ? (
              <video
                className={`${s.projectVideo} ${
                  hoveredProject === project.id ? s.visible : s.hidden
                }`}
                src={process.env.PUBLIC_URL + project.video}
                type="video/mp4"
                muted
                loop
                playsInline
                onMouseEnter={(e) => {
                  const video = e.target;
                  video.play().catch((err) => {
                    console.warn("Видео не смогло запуститься:", err);
                  });
                }}
                onMouseLeave={(e) => {
                  const video = e.target;
                  if (!video.paused) {
                    video.pause();
                  }
                  video.currentTime = 0;
                }}
                onError={(e) => {
                  console.error("Ошибка загрузки видео", e);
                }}
              />
            ) : (
              <div className={s.placeholderVideo}></div>
            )}
          </Link>

          <div className={s.projectTitle}>{project.title}</div>
        </div>
      ))}
    </div>
  );
}
